import React, { useState } from 'react';
import ModalFromConfirmationComponent from './modal-form-confirmation.component';

const ModalFormConfirmation = (props) => {
    const [double, setDouble] = useState(false);
    return <ModalFromConfirmationComponent {...props} double={double} setDouble={setDouble} />;
};

export default ModalFormConfirmation;
